import { useEffect, useState } from "react";
import axios from "axios";
import { API } from "@/lib/api";
import { Sparkle } from "@phosphor-icons/react";

// Fetches (and caches server-side) a warm AI "about" blurb for a place or category
// via GET /api/public/location-intro. Renders nothing until it resolves.
export default function AiIntro({ place, kind = "category", parent = "", label = "About this collection", className = "" }) {
  const [intro, setIntro] = useState(null);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (!place) { setIntro(null); return; }
    setLoading(true); setIntro(null);
    const p = new URLSearchParams({ place, kind, parent });
    axios.get(`${API}/public/location-intro?${p.toString()}`)
      .then((r) => setIntro(r.data?.intro || null))
      .catch(() => setIntro(null))
      .finally(() => setLoading(false));
  }, [place, kind, parent]);

  if (loading)
    return <div data-testid="ai-intro-loading" className={`h-16 animate-pulse rounded-2xl bg-zinc-100 ${className}`} />;
  if (!intro) return null;
  return (
    <div data-testid="ai-intro" className={`rounded-2xl border border-[#F27A54]/25 bg-[#FFF7F2] p-4 sm:p-5 ${className}`}>
      <p className="overline flex items-center gap-1.5 text-[10px] text-[#F27A54]"><Sparkle size={13} weight="fill" /> {label}</p>
      <p className="mt-1.5 text-sm leading-relaxed text-zinc-700 sm:text-base">{intro}</p>
    </div>
  );
}
